import Home from "./Home";
import HomeDesktop from "./HomeDesktop";

export { HomeDesktop };
export default Home;
